import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import InputWithCharacterCounter from '../../../slides/highlighted/common/InputWithCharacterCounter';
import {ProtectionInfo, ProtectionType} from '../../../../incase-domain/presentationProtection';
import ProtectionOptionsFormWrapper from './ProtectionOptionsFormWrapper';
import {randomString} from '../../../../utils/utils';
import TooltipWrapper from '../../../../ui/components/common/TooltipWrapper';

interface IdentificationFormProps {
    protection: ProtectionInfo;
    setProtection: (protection: ProtectionInfo) => void;
}

function IdentificationForm({protection, setProtection}: IdentificationFormProps): JSX.Element {
    const {t} = useTranslation();
    const [labelError, setLabelError] = useState<string>('');
    const identificationProtected = protection.types.includes(ProtectionType.IDENTIFICATION);

    const setLabel = (label: string): void => {
        setProtection({
            ...protection,
            identificationLabel: label,
        });
        if (!label) {
            setLabelError(t('presEditPage.settings.requestParameters.required'));
        } else {
            setLabelError('');
        }
    };

    const handleAddIdentification = (): void => {
        setProtection({
            ...protection,
            types: protection.types.filter((t) => t !== ProtectionType.GUEST).concat(ProtectionType.IDENTIFICATION),
            identificationLabel: 'username',
        });
    };

    const handleRemoveIdentification = (): void => {
        // if both IDENTIFICATION and PASSWORD are removed, add GUEST
        const noIdentificationType = !protection.types.includes(ProtectionType.PASSWORD);
        setProtection({
            ...protection,
            types: protection.types
                .filter((t) => t !== ProtectionType.IDENTIFICATION)
                .concat(noIdentificationType ? ProtectionType.GUEST : []),
            identificationLabel: '',
        });
    };

    return (
        <ProtectionOptionsFormWrapper
            label={t('roomsPage.editRoomModal.identification')}
            checked={identificationProtected}
            onToggle={identificationProtected ? handleRemoveIdentification : handleAddIdentification}
        >
            <TooltipWrapper id={randomString(10)} content={t('presEditPage.settings.presProtection.label')} delayShow={500}>
                <div>
                    <InputWithCharacterCounter
                        className="c-sidepanel__input"
                        placeholder={t('presEditPage.settings.presProtection.label')}
                        value={protection.identificationLabel || ''}
                        onChange={(value) => setLabel(value)}
                        dataCy="protection_identification_input"
                        error={labelError}
                    />
                </div>
            </TooltipWrapper>
        </ProtectionOptionsFormWrapper>
    );
}

export default IdentificationForm;
